<div *ngIf="sectionTitle" class="row no-gutters mt-3">
  <div class="col">
    <h4>{{sectionTitle}}</h4>
  </div>
</div>

<ng-template #valueTemplate
             let-valueinput="value"
             let-elementinput="element"
             let-columninput="column">
  <ng-container *ngIf="columninput['columnName']==='active'">
    <ng-container *ngIf="valueinput===true">
      <i class="fas fa-circle limegreen"></i>
    </ng-container>
    <ng-container *ngIf="valueinput===false">
      <i class="fas fa-circle red"></i>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="columninput['columnName']!=='active'">
    {{valueinput}}
  </ng-container>
</ng-template>

<app-crud-list [observabledata]="getObservableData()"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityadminuri"
               [deleteEntityHandler]="deleteEntityHandler()"
               [listEditPathCallback]="getListEditPathCallback()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [specificColumnsTemplates]="[
                        {key: 'active', template:valueTemplate}
                       ]"
>
</app-crud-list>
